enum RequestStatus {
  NOT_STARTED = "NOT_STARTED",
  REQUESTING = "REQUESTING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

interface ICustomHeaders {
  [key: string]: string;
}

interface IError {
  [key: string]: string;
}

interface IRequestOptions {
  method: string;
  credentials: "omit" | "same-origin" | "include" | undefined;
  mode: "cors";
  headers: ICustomHeaders;
  body?: string;
}

export { RequestStatus, IError, IRequestOptions };
